import { useContext } from 'react';

import { EmbedBootstrapContext, type EmbedBootstrapValue } from './widget-bootstrap-context';

export function useEmbedBootstrap(): EmbedBootstrapValue {
  const v = useContext(EmbedBootstrapContext);
  if (!v) {
    throw new Error('useEmbedBootstrap: провайдер не подключён');
  }
  return v;
}
